<div class="settings-tab-new-persona-wrapper" #wrapperContainer [ngClass]="{ 'onboarding-active': isOnboarding }">
  <div class="settings-tab-new-persona-container">
    <header class="settings-tab-new-persona-header">
      <div class="settings-tab-new-persona-row row-left">
        <a class="settings-tab-new-persona-go-back" (click)="goBack()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask
              id="mask0_660_73356"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_660_73356)">
              <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" fill="#2A1E36" />
            </g>
          </svg>
          <strong>Go Back</strong>
        </a>
      </div>
      <h1 class="settings-tab-new-persona-header-title">{{ userPersonaId ? "Edit Persona" : "Add New Persona" }}</h1>
      <p class="settings-tab-new-persona-header-subtitle">
        You'll define who we are speaking as when we generate posts, comments, and more.
      </p>
    </header>
    <form
      class="clearfix form settings-tab-new-persona-form"
      [formGroup]="form"
      (ngSubmit)="form.valid && savePersona()"
    >
      <div vngTourAnchor="step14">
        <div class="settings-tab-new-persona-row row-between">
          <div class="settings-tab-new-persona-input-container no-border">
            <label for="type">
              Tag<strong>*</strong>
              <i
                ngbPopover="Tag this persona to categorize it as a personal or corporate voice."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>

            <vng-radio-group
              [formControl]="form.controls['type']"
              aria-label="Select a license"
              class="license-options"
              orientation="horizontal"
              id="type"
            >
              <vng-radio-button value="person" class="plan-radio-button" style="margin-right: 20px">
                Person
              </vng-radio-button>
              <vng-radio-button value="company" class="plan-radio-button"> Company </vng-radio-button>
            </vng-radio-group>
          </div>

          <div class="settings-tab-new-persona-input-container no-border">
            <label for="type">
              Default Persona
              <i
                ngbPopover="Check this box if you want this persona to be the default persona for all your posts."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>

            <vng-radio-group
              [formControl]="form.controls['is_default']"
              aria-label="Select a license"
              class="license-options"
              orientation="horizontal"
              id="type"
            >
              <vng-radio-button [value]="true" class="plan-radio-button" style="margin-right: 20px">
                Yes
              </vng-radio-button>
              <vng-radio-button [value]="false" class="plan-radio-button"> No </vng-radio-button>
            </vng-radio-group>
          </div>
        </div>

        <div class="settings-tab-new-persona-row row-between">
          <div class="settings-tab-new-persona-input-container">
            <ng-template #popoverContent>
              Give this Persona a name to help trigger your memory on which to use when we are writing for you (e.g.
              "Friendly Mario", "Professional Mario", etc.)
            </ng-template>
            <label for="name">
              Title Your Persona<strong>*</strong>
              <i [ngbPopover]="popoverContent" popoverClass="settings-tab-new-persona-popover" placement="top">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>
            <vng-input
              id="name"
              type="text"
              placeholder="Ex. Mario’s CEO Friendly Voice"
              [flyMsgIgnore]="true"
              [formControl]="form.controls['name']"
            ></vng-input>
          </div>
          <div class="settings-tab-new-persona-input-container no-padding">
            <ng-template #professionalInterestsPopover>
              Identify any professional interest this persona will have associated with it.
              <br />
              (separated by commas or pressing the enter key)
            </ng-template>
            <label for="professional_interests">
              Professional Interests<strong>*</strong>
              <i
                [ngbPopover]="professionalInterestsPopover"
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>
            <vng-chip-input
              id="professional_interests"
              formControlName="professional_interests"
              placeholder="Ex. sales, security, development, etc."
              [addOnBlur]="true"
              [allowDuplicates]="true"
              [flyMsgIgnore]="true"
              (chipsChange)="markChipsTouched()"
            ></vng-chip-input>
          </div>
        </div>

        <div *ngIf="form.controls['type'].value == 'person'" class="settings-tab-new-persona-row row-between">
          <div class="settings-tab-new-persona-input-container">
            <label for="first_name"> First Name<strong>*</strong> </label>
            <vng-input
              type="text"
              id="first_name"
              placeholder="Ex. John"
              [flyMsgIgnore]="true"
              [formControl]="form.controls['first_name']"
            ></vng-input>
          </div>
          <div class="settings-tab-new-persona-input-container">
            <label for="last_name"> Last Name<strong>*</strong> </label>
            <vng-input
              id="last_name"
              type="text"
              placeholder="Ex. Doe"
              [flyMsgIgnore]="true"
              [formControl]="form.controls['last_name']"
            ></vng-input>
          </div>
        </div>

        <div *ngIf="form.controls['type'].value == 'company'" class="settings-tab-new-persona-row row-between">
          <div class="settings-tab-new-persona-input-container">
            <label for="company_name">
              Company Name<strong>*</strong>
              <i
                ngbPopover="Use this to define a company name associated with your personal brand. If none, or if not necessary, leave blank."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>
            <vng-input
              id="company_name"
              type="text"
              placeholder="Ex. Vengreso"
              [flyMsgIgnore]="true"
              [formControl]="form.controls['company_name']"
            ></vng-input>
          </div>
        </div>

        <div class="settings-tab-new-persona-row row-between">
          <div class="settings-tab-new-persona-input-container">
            <label for="industry">
              Industry<strong>*</strong>
              <i
                ngbPopover="Add an industry perspective to help shape this persona’s voice."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>
            <vng-input
              id="industry"
              type="text"
              placeholder="Ex. Computer Software, SaaS, etc."
              [flyMsgIgnore]="true"
              [formControl]="form.controls['industry']"
            ></vng-input>
          </div>
          <div class="settings-tab-new-persona-input-container">
            <label for="tone">
              Tone<strong>*</strong>
              <i
                ngbPopover="Select a tone that this persona will always use when FlyMSG is writing for you."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </label>
            <vng-select
              placeholder="Select"
              id="tone"
              [formControl]="form.controls['prompt_tone_id']"
              [options]="toneOptions"
            ></vng-select>
          </div>
        </div>
      </div>

      <hr class="settings-tab-new-persona-hr-separator" vngTourAnchor="step14-start" />

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container">
          <label for="linkedin_url"> LinkedIn URL</label>
          <vng-input
            id="linkedin_url"
            type="text"
            placeholder="Insert Your Personal or Company LinkedIn URL "
            [flyMsgIgnore]="true"
            [formControl]="form.controls['linkedin_url']"
          ></vng-input>
        </div>
        <div class="settings-tab-new-persona-input-container">
          <label for="achievements">
            Achievements
            <i
              ngbPopover="List out all of your personal achievements here so your AI persona emulates you best."
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-input
            id="achievements"
            type="text"
            placeholder="Ex. B2B Marketing, Field Marketing, SEO,etc."
            [flyMsgIgnore]="true"
            [formControl]="form.controls['achievements']"
          ></vng-input>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #preferredPhrasesPopover>
            Enter words that you commonly use when speaking or writing. For example: "Boom" or "Totally". Note, AI will
            use these words when we emulate you.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="preferredPhrases">
            Preferred Phrases
            <i [ngbPopover]="preferredPhrasesPopover" popoverClass="settings-tab-new-persona-popover" placement="top">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="preferredPhrases"
            formControlName="preferred_keywords_and_phrases"
            placeholder="Ex. Boom!, Fire!, Totally, You got that right!, A fool with a tool, is still a fool!, etc."
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #communicationStylePopover>
            List your communication style separated by commas so the AI persona emulates you best.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="communication_style">
            Communication Style
            <i [ngbPopover]="communicationStylePopover" popoverClass="settings-tab-new-persona-popover" placement="top">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="communication_style"
            formControlName="communication_style"
            placeholder="Ex. Conversational, Authentic, etc."
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
        <div *ngIf="form.controls['type'].value == 'person'" class="settings-tab-new-persona-input-container">
          <label for="company_name">
            Company Name
            <i
              ngbPopover="Use this to define a company name associated with your personal brand. If none, or if not necessary, leave blank."
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-input
            id="company_name"
            type="text"
            placeholder="Ex. Vengreso"
            [flyMsgIgnore]="true"
            [formControl]="form.controls['company_name']"
          ></vng-input>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #educationBackgroundPopover>
            Enter words that identify your educational background for AI to better emulate you.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="educationBackground">
            Education Background
            <i
              [ngbPopover]="educationBackgroundPopover"
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="educationBackground"
            formControlName="education_background"
            placeholder="Ex. Running, Reading, Rapping, Improv, etc"
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <label for="field_of_expertise">
            Field of Expertise
            <i
              ngbPopover="Here you will want to tell us your various fields of expertise like Digital Marketing, Email Marketing Strategy, SEO, etc."
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="field_of_expertise"
            formControlName="field_of_expertise"
            placeholder="Ex. B2B Marketing, Field Marketing, SEO,etc."
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container">
          <label for="goals">
            Goals
            <i
              ngbPopover="Here identify what you want your business goals to be as associated with this persona."
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-input
            id="goals"
            type="text"
            placeholder="Ex. Help 10 companies with digital marketing strategy, engage with more target buyers, etc."
            [flyMsgIgnore]="true"
            [formControl]="form.controls['goals']"
          ></vng-input>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #hobbiesPopover>
            Enter words that identify your hobbies for AI to better emulate you.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="hobbies">
            Hobbies
            <i [ngbPopover]="hobbiesPopover" popoverClass="settings-tab-new-persona-popover" placement="top">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="hobbies"
            formControlName="hobbies"
            placeholder="Ex. Running, Reading, Rapping, Improv, etc"
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #personalInterestsPopover>
            Enter words that identify your personal interest for AI to better emulate you.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="personalInterests">
            Personal Interests
            <i [ngbPopover]="personalInterestsPopover" popoverClass="settings-tab-new-persona-popover" placement="top">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="personalInterests"
            formControlName="personal_interests"
            placeholder="Ex. Chess, Comedy, Basketball, etc"
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container no-padding">
          <label for="skills">
            Skills
            <i
              ngbPopover="List any relevant skills you want AI to know about you as associated with this persona. "
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="skills"
            formControlName="skills"
            placeholder="Ex. SEO, Copy Writing, Social Media, etc."
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
        <div class="settings-tab-new-persona-input-container no-padding">
          <ng-template #taboosPopover>
            Enter words or topics that you would want your Ai persona to never talk about and stay away from.
            <br />
            (separated by commas or pressing the enter key)
          </ng-template>
          <label for="taboos">
            Taboos
            <i [ngbPopover]="taboosPopover" popoverClass="settings-tab-new-persona-popover" placement="top">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-chip-input
            id="taboos"
            formControlName="taboos"
            placeholder="Ex. Politics, Religion, Gossip etc"
            [addOnBlur]="true"
            [allowDuplicates]="true"
            [flyMsgIgnore]="true"
            (chipsChange)="markChipsTouched()"
          ></vng-chip-input>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container">
          <label for="title">
            Title
            <i
              ngbPopover="Adding your title to your AI persona helps AI to understand who you are."
              popoverClass="settings-tab-new-persona-popover"
              placement="top"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                  fill="#F15A2A"
                />
                <path
                  d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                  fill="white"
                />
                <path
                  d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                  fill="white"
                />
              </svg>
            </i>
          </label>
          <vng-input
            type="text"
            placeholder="CEO, Account Executive, , CTO, Doctor, etc."
            [flyMsgIgnore]="true"
            [formControl]="form.controls['title']"
          ></vng-input>
        </div>
      </div>

      <hr class="settings-tab-new-persona-hr-separator" />

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container is-textarea">
          <label for="content">
            <span>
              Content
              <i
                ngbPopover="Add in any content call to action(s) so your AI persona can possibly incorporate that into its writing for you. "
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </span>
            <span
              [ngClass]="{
                'limit-exceeded': form.controls['content'].value?.length > 1000
              }"
            >
              {{ form.controls["content"].value?.length ?? 0 | number : "1.0-0" }}/1,000
            </span>
          </label>
          <vng-textarea
            id="content"
            placeholder="Ex. Promote my Marketing funnel webinar at FlyMSG.ai, Tell people to listen to The Modern Selling Podcast, etc."
            [flyMsgIgnore]="true"
            [formControl]="form.controls['content']"
          ></vng-textarea>
        </div>
      </div>

      <div class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container is-textarea">
          <label for="networking">
            <span>
              Networking
              <i
                ngbPopover="Identify your Networking goals so AI knows when writing for you what your foremost goals are. "
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </span>
            <span
              [ngClass]="{
                'limit-exceeded': form.controls['networking'].value?.length > 1000
              }"
            >
              {{ form.controls["networking"].value?.length ?? 0 | number : "1.0-0" }}/1,000
            </span>
          </label>
          <vng-textarea
            id="networking"
            placeholder="Ex. Connect with Marketing Directors, Network with ecommerce company CEOs, etc."
            [flyMsgIgnore]="true"
            [formControl]="form.controls['networking']"
          ></vng-textarea>
        </div>
      </div>

      <div *ngIf="false" class="settings-tab-new-persona-row row-between">
        <div class="settings-tab-new-persona-input-container is-textarea">
          <label for="personal_info">
            <span>
              Personal Info
              <i
                ngbPopover="Add any relevant personal information so AI can better understand you and write like you."
                popoverClass="settings-tab-new-persona-popover"
                placement="top"
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                    fill="#F15A2A"
                  />
                  <path
                    d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                    fill="white"
                  />
                  <path
                    d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                    fill="white"
                  />
                </svg>
              </i>
            </span>
            <span
              [ngClass]="{
                'limit-exceeded': form.controls['personal_info'].value?.length > 1000
              }"
            >
              {{ form.controls["personal_info"].value?.length ?? 0 | number : "1.0-0" }}/1,000
            </span>
          </label>
          <vng-textarea
            id="personal_info"
            placeholder="Ex. Single father of 5 kids"
            [flyMsgIgnore]="true"
            [formControl]="form.controls['personal_info']"
          ></vng-textarea>
        </div>
      </div>

      <hr
        *ngIf="form.controls['ai_emulation'].value"
        class="settings-tab-new-persona-hr-separator"
        vngTourAnchor="step16-end"
      />

      <div vngTourAnchor="step16">
        <div
          *ngIf="staleEmulation && form.controls['ai_emulation'].value"
          class="tw-flex tw-items-start tw-gap-2 tw-mb-3 tw-rounded tw-bg-amber-50 tw-px-3 tw-py-2 tw-text-sm tw-text-amber-800"
          data-fms-heap="persona-stale-emulation-banner"
        >
          <vng-icon name="warning" [outline]="false" [size]="18" color="warning"></vng-icon>
          <span>
            This AI emulation is out of date — the persona details changed after it was generated. Click Regenerate
            to refresh it.
            <ng-container *ngIf="!canRegenerate && refillCountdown">
              Prompts refill in {{ refillCountdown }}.
            </ng-container>
          </span>
        </div>

        <div class="settings-tab-new-persona-row row-between" *ngIf="form.controls['ai_emulation'].value">
          <div class="settings-tab-new-persona-input-container is-textarea is-ai-emulation disabled">
            <label for="ai_emulation">
              <span>
                AI Emulation For This Persona
                <i
                  ngbPopover="Once you hit generate persona we will generate a sample copy of your writing. To change the output continue modifying the fields above."
                  popoverClass="settings-tab-new-persona-popover"
                  placement="top"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.00521 1.33268C4.32331 1.33268 1.33854 4.31745 1.33854 7.99935C1.33854 11.6812 4.32331 14.666 8.00521 14.666C11.6871 14.666 14.6719 11.6812 14.6719 7.99935C14.6719 4.31745 11.6871 1.33268 8.00521 1.33268Z"
                      fill="#F15A2A"
                    />
                    <path
                      d="M8 6.83268C7.72667 6.83268 7.5 7.05935 7.5 7.33268V10.666C7.5 10.9393 7.72667 11.166 8 11.166C8.27333 11.166 8.5 10.9393 8.5 10.666V7.33268C8.5 7.05935 8.27333 6.83268 8 6.83268Z"
                      fill="white"
                    />
                    <path
                      d="M7.39188 5.58707C7.42521 5.66707 7.47188 5.7404 7.53188 5.80707C7.59854 5.86707 7.67188 5.91374 7.75188 5.94707C7.91188 6.01374 8.09854 6.01374 8.25854 5.94707C8.33854 5.91374 8.41188 5.86707 8.47854 5.80707C8.53854 5.7404 8.58521 5.66707 8.61854 5.58707C8.65188 5.50707 8.67188 5.4204 8.67188 5.33374C8.67188 5.24707 8.65188 5.1604 8.61854 5.0804C8.58521 4.99374 8.53854 4.92707 8.47854 4.8604C8.41188 4.8004 8.33854 4.75374 8.25854 4.7204C8.17854 4.68707 8.09188 4.66707 8.00521 4.66707C7.91854 4.66707 7.83188 4.68707 7.75188 4.7204C7.67188 4.75374 7.59854 4.8004 7.53188 4.8604C7.47188 4.92707 7.42521 4.99374 7.39188 5.0804C7.35854 5.1604 7.33854 5.24707 7.33854 5.33374C7.33854 5.4204 7.35854 5.50707 7.39188 5.58707Z"
                      fill="white"
                    />
                  </svg>
                </i>
              </span>
              <button
                type="button"
                (click)="copyToClipboard()"
                class="settings-tab-new-persona-ai-emulation-copy"
                ngbPopover="Copy to Clipboard"
                popoverClass="settings-tab-new-persona-popover no-width"
                placement="top"
              >
                <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14 0.875H3.5C2.5375 0.875 1.75 1.6625 1.75 2.625V14.875H3.5V2.625H14V0.875ZM16.625 4.375H7C6.0375 4.375 5.25 5.1625 5.25 6.125V18.375C5.25 19.3375 6.0375 20.125 7 20.125H16.625C17.5875 20.125 18.375 19.3375 18.375 18.375V6.125C18.375 5.1625 17.5875 4.375 16.625 4.375ZM16.625 18.375H7V6.125H16.625V18.375Z"
                    fill="#5F177F"
                  />
                </svg>
              </button>
            </label>
            <markdown [data]="form.controls['ai_emulation']?.value" class="ai-emulation-md-container"></markdown>
          </div>
        </div>
        <!-- quota.total === -1 means unlimited (e.g. Sales Pro/Teams) — no counter, no countdown, no hint to show. -->
        <div *ngIf="quota.total !== -1" class="tw-mt-4 tw-mb-2">
          <div class="settings-persona-ai-emulation-prompts">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="16" height="16" rx="0.913462" fill="url(#paint0_linear_10612_61635)" />
              <path
                d="M10.142 11H8.79749L8.26305 9.63711H5.81628L5.31106 11H4L6.38413 5H7.69102L10.142 11ZM7.86639 8.62619L7.02296 6.39973L6.19624 8.62619H7.86639Z"
                fill="white"
              />
              <path d="M10.7641 11V5H12V11H10.7641Z" fill="white" />
              <defs>
                <linearGradient
                  id="paint0_linear_10612_61635"
                  x1="2.15597e-07"
                  y1="8"
                  x2="15"
                  y2="16"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#5F177F" />
                  <stop offset="1" stop-color="#F15A2A" />
                </linearGradient>
              </defs>
            </svg>
            {{ quota.remaining }}/{{ quota.total }} Prompts Per Day
            <ng-container *ngIf="refillCountdown"> · refills in {{ refillCountdown }}</ng-container>
          </div>
          <p class="tw-text-xs tw-text-gray-500 tw-mt-1" data-fms-heap="persona-quota-hint">
            Your first {{ quotaMeta.freeGenerations === 1 ? "generation" : quotaMeta.freeGenerations + " generations" }}
            of a persona {{ quotaMeta.freeGenerations === 1 ? "is" : "are" }} free. Each Regenerate uses 1 of your
            daily AI prompts.
          </p>
        </div>

        <div class="settings-tab-new-persona-row row-left" *ngIf="form.controls['ai_emulation'].value">
          <button
            vng-button
            variant="outline"
            size="lg"
            type="button"
            (click)="generateAIEmulation(true)"
            [disabled]="updating || isOnboarding"
            vngTourAnchor="step16-start"
          >
            {{ updating ? "Regenerating..." : "Regenerate" }}
          </button>
        </div>

        <footer #footerElement>
          <button
            *ngIf="!form.controls['ai_emulation'].value"
            vng-button
            variant="primary"
            size="lg"
            type="button"
            (click)="generateAIEmulation()"
            vngTourAnchor="step15"
            [disabled]="form.invalid || updating"
          >
            {{ updating ? "Generating..." : "Generate Persona" }}
          </button>
          <button
            *ngIf="form.controls['ai_emulation'].value"
            vng-button
            variant="outline"
            size="lg"
            type="button"
            (click)="goBack()"
            [disabled]="updating || isOnboarding"
            vngTourAnchor="step15-end"
          >
            Cancel
          </button>
          <button
            [ngbPopover]="
              (form.invalid || !form.untouched) && !updating
                ? !form.untouched && !canRegenerate
                  ? 'You\'re out of AI prompts for today. You can save now — this persona will be marked as needing regeneration until you Regenerate it.'
                  : 'You need to Regenerate your AI Emulation before saving the changes.'
                : ''
            "
            popoverClass="settings-tab-new-persona-popover"
            *ngIf="form.controls['ai_emulation'].value"
            vng-button
            variant="primary"
            size="lg"
            type="submit"
            [disabled]="form.invalid || updating || (!form.untouched && canRegenerate)"
          >
            Save Persona
          </button>
        </footer>
      </div>
    </form>
  </div>
</div>
